export const GET_PROFILE_LOADING='get/profile/loading';
export const GET_PROFILE_SUCCESS='get/profile/success';
export const GET_PROFILE_FAILURE='get/profile/failure';

export const GET_USER_DETAILS_LOADING='get/user/details/loading';
export const GET_USER_DETAILS_SUCCESS='get/user/details/success';
export const GET_USER_DETAILS_FAILURE='get/user/details/failure';

export const UPDATE_PROFILE_LOADING='update/profile/loading';
export const UPDATE_PROFILE_SUCCESS='update/profile/success';
export const UPDATE_PROFILE_FAILURE='update/profile/failure';